import { Carousel } from "react-responsive-carousel";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listHeroFooter } from "../actions/heroActions";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Message from "./Message";
import Loader from "./Loader";

const getConfigurableProps = () => ({
  showArrows: true,
  showStatus: false,
  showIndicators: true,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  autoPlay: true,
  stopOnHover: true,
  swipeable: true,
  dynamicHeight: false,
  emulateTouch: true,
  autoFocus: false,
  thumbWidth: 100,
  selectedItem: 0,
  interval: 4000,
  transitionTime: 900,
  ariaLabel: "ariaLabel",
});

export default function FooterHero() {
  const dispatch = useDispatch();

  const heroListFooter = useSelector((state) => state.heroListFooter);
  const { loading, heros, error } = heroListFooter;

  const [country, setCountry] = useState("india");

  const { t, i18n } = useTranslation();
  let lang = i18n.language;

  useEffect(() => {
    if (lang === "en") {
      setCountry("india");
    } else {
      setCountry("germany");
    }
  }, [lang, i18n]);

  useEffect(() => {
    dispatch(listHeroFooter(country, "footerHero"));
  }, [country, dispatch]);

  // const delay = 1 * 60; // delay duration
  // const [showGif, setShowGif] = useState(false);
  // const [remainingTime, setRemainingTime] = useState(delay);

  // useEffect(() => {
  //   if (remainingTime === 0) {
  //     setShowGif(true);
  //     return;
  //   }

  //   const timerId = setTimeout(() => {
  //     setRemainingTime(prev => prev - 1);
  //   }, 1000);

  //   return () => clearTimeout(timerId);
  // }, [remainingTime]);

  return (
    <div className="bg-white">
      {loading ? (
        <div className="w-full bg-white animate-pulse">
          <div className="flex items-center justify-center bg-slate-200 bg-no-repeat bg-animate animate-pulse">
            <Loader />
          </div>
        </div>
      ) : error ? (
        <Message type="error">{error}</Message>
      ) : (
        <div className="w-full bg-white">
          <Carousel {...getConfigurableProps()}
            showIndicators={heros.length > 1}
            showStatus={false}>
            {heros.map((hero, index) => (
              <div key={index}>
                <RouterLink className="block h-full" to={`${hero.link}`}>
                  {/* {showGif ? ( */}
                    <img loading="lazy" src={`${hero.url}`} alt="banner" />
                  {/* ) : (
                    <div style={{ height: '200px', background: '#eee', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '18px' }}>
                      Playing in {remainingTime} second{remainingTime !== 1 ? 's' : ''}
                    </div>
                  )} */}
                </RouterLink>
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
}
